import { forEach } from './forEach';
import { getListType, getNewList, setListValue } from './listAccess';
/**
 * Works like Array.map() but for any valid list object
 * @param list The array or object to iterate
 * @param callback The callback to apply. Params are: (value, key)
 */
export function map(list, callback) {
    var output = getNewList(getListType(list));
    forEach(list, function (v, k) {
        setListValue(output, callback(v, k, list), k);
    });
    return output;
}
//# sourceMappingURL=map.js.map